import { Component, OnInit, ViewChild } from '@angular/core';
import { first } from 'rxjs/operators';
import { PropertyService, Property } from '@app/_components/property';
import { AlertService, AuthenticationService, ConstantService, DataCacheService } from '@app/_services';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectItem, LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { Locations, ListingStatus } from '@app/_helpers/constants';
import { Table } from 'primeng/table';
import { Dropdown } from 'primeng/dropdown';
import {ImportExportComponent} from '@app/_components/_helpers/import-export/import-export.component';
import * as moment from 'moment';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {PublicTaskListComponent} from '@app/_components/task/public-task-list/public-task-list.component';
import { ReservationService } from '@app/_components/reservation/reservation.service';
@Component({
    selector: 'app-property-list',
    templateUrl: './property-list.component.html',
    styleUrls: ['./property-list.component.css'],
    providers: [MessageService],
    standalone: false
})
export class PropertyListComponent implements OnInit {
	@ViewChild('pt') pt: Table | undefined;
	@ViewChild('aa') public aa: Dropdown;
	datasource: Property[];
	property: Property;
	properties: Property[] = [];
	columns: any[];
	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	userStatusOptions: SelectItem[];
	listingStatusObj: any = 0;

	listingStatuses = [
		{ value: 0, name: 'Active' },
		{ value: 2, name: 'Suspended' },
		{ value: 1, name: 'Canceled' }
	];

    locations: any;
	sitePriorities: any;
	@ViewChild(ImportExportComponent) importExportComponent: ImportExportComponent;
	listingStatusFlag = false;
	listingTypes: any;
	locationIds: any[];
	isSpinner = false;
	/**
	 * Operations-dashboard handoff: cells like "All Active Units — Big Island"
	 * navigate here with ?locationId=3 (and optionally ?listingStatus=0). The
	 * table picks these up in ngOnInit and pre-applies them to the PrimeNG
	 * filters so the page lands already scoped to that location.
	 *
	 * Banner above the table reads from inheritedFilterSummary so the user
	 * sees where the filters came from and how to clear them.
	 */
	inheritedFilterSummary: string | null = null;
	private inheritedLocationId: number | null = null;
	private inheritedListingStatus: number | null = null;
	private inheritedListingType: number | null = null;

	constructor(
		private authenticationService: AuthenticationService,
		private propertyService: PropertyService,
		private dataCacheService: DataCacheService,
		private alertService: AlertService,
		private confirmationService: ConfirmationService,
		private messageService: MessageService,
		private reservationService: ReservationService,
		private constantService: ConstantService,
    private dialog: MatDialog,

		private activatedRoute: ActivatedRoute,
		private router: Router
	) {
		this.locations = this.constantService.locations;
		this.sitePriorities = propertyService.sitePriorities;
		this.listingTypes = this.reservationService.listingTypes;
		this.locationIds = this.constantService.locations;

		// Read dashboard-handoff query params in the constructor (not ngOnInit)
		// so they're set before the first lazy-load fires.
		const params = this.activatedRoute.snapshot.queryParamMap;
		const locParam = params.get('locationId');
		const statusParam = params.get('listingStatus');
		const typeParam = params.get('listingType');
		if (locParam != null) {
			const n = Number(locParam);
			if (!Number.isNaN(n)) this.inheritedLocationId = n;
		}
		if (statusParam != null) {
			const n = Number(statusParam);
			if (!Number.isNaN(n)) this.inheritedListingStatus = n;
		}
		if (typeParam != null) {
			const n = Number(typeParam);
			if (!Number.isNaN(n)) this.inheritedListingType = n;
		}
		const parts: string[] = [];
		if (this.inheritedLocationId != null) {
			const loc = this.locations?.find?.((l: any) => l.locationId === this.inheritedLocationId);
			parts.push(`Location: ${loc?.name ?? this.inheritedLocationId}`);
		}
		if (this.inheritedListingStatus != null) {
			const s = this.listingStatuses.find(x => x.value === this.inheritedListingStatus);
			parts.push(`Status: ${s?.name ?? this.inheritedListingStatus}`);
		}
		if (this.inheritedListingType != null) {
			const t = this.listingTypes?.find?.((x: any) => x.value === this.inheritedListingType);
			parts.push(`Listing Type: ${t?.name ?? this.inheritedListingType}`);
		}
		this.inheritedFilterSummary = parts.length ? parts.join('  ·  ') : null;
	}


	ngOnInit() {
		this.listingStatusFlag = true;
		try {
			this.columns = [
				{ field: 'shortTermRentalId', header: 'Id' },
				{ field: 'lastUpdate', header: 'Updated' },
				{ field: 'listingStatus', header: 'Status' },
				{ field: 'locationId', header: 'Location' },
				{ field: 'adrRegion', header: 'Region' },
				{ field: 'adrDistrictName', header: 'District' },
				{ field: 'propertyCode', header: 'Code' },
				{ field: 'adrBuildingName', header: 'Building' },
				{ field: 'floorOfProperty', header: 'Floor' },
				{ field: 'bedroomNum', header: 'Beds' },
				{ field: 'bathroomNum', header: 'Baths' },
				{ field: 'sleepsMax', header: 'Sleeps' },
			];
		} catch (error) {
			console.log('ngOnInit() ' + error);

		}
	}

	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);
			if(this.listingStatusFlag){
				// Default to Active (listingStatus=0) UNLESS the URL handoff
				// asked for a different status (e.g. ?listingStatus=2 for
				// Suspended). Per-call locationId AND listingType pre-filters
				// also applied — listingType=1 from the dashboard means real
				// Short-Term Rental units only, excluding composite parents
				// (type 2), which keeps the row count tracking the tile.
				const statusToUse = this.inheritedListingStatus != null
					? this.inheritedListingStatus
					: 0;
				const presetFilters: any = {
					'listingStatus': { 'value': statusToUse, 'matchMode': 'in' }
				};
				if (this.inheritedLocationId != null) {
					presetFilters['locationId'] = { 'value': [this.inheritedLocationId], 'matchMode': 'in' };
				}
				if (this.inheritedListingType != null) {
					presetFilters['listingType'] = { 'value': [this.inheritedListingType], 'matchMode': 'in' };
				}
				Object.assign(event.filters, presetFilters);
				this.listingStatusFlag = false;
			}

			

			const pageNumber = Math.round(event.first / event.rows);
			this.propertyService.findAgentListByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					data => {
						console.log('properties are: ' + JSON.stringify(data));
						this.datasource = data.data.properties;
						this.recordTotal = data.page.recordTotal;
						this.properties = data.data.properties;
					},
					error => {
						console.log('properties list error!: ' + JSON.stringify(error));
						this.alertService.error(error);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.properties = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}
	onRowSelect(event) {
		try {
			this.loading = true;
			// console.log('onRowSelect(' + JSON.stringify(event) + ')');
			// use this for adding query params
			// this.router.navigate(['user-edit'], { queryParams: { userId: event.data.userId } });
			this.router.navigate(['property-edit', event.data.shortTermRentalId]);
		} catch (error) {
			console.log('onRowSelect(' + event + ')' + error);
		}
	}

	get Locations() {
		return Locations;
	}
	get ListingStatus() {
		return ListingStatus;
	}

	reloadPage() {
		window.location.reload();
	}



	onCopyToNewPropertyClick(property: any) {

		this.confirmationService.confirm({
			message: 'Are you sure you want to copy ' + property.propertyCode + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.copyToNewProperty(property)
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Copy canceled.', life: 3000 });
			}
		});
	}



	copyToNewProperty(property: any) {
		try {
			this.loading = true;

			this.propertyService.copyToNewProperty(property.shortTermRentalId)
				.subscribe(
					res => {
						console.log('copyToNewProperty SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success!', detail: res.message, sticky: false });
					},
					err => {
						console.log('property-find FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message, sticky: true });
						this.loading = false;
					},
					() => { this.loading = false; });

		} catch (error) {
			this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message, sticky: true });
			this.loading = false;
		}
	}

	formUpdate(property: any) {
		try {
			 console.log('property-before-updateS: ' + JSON.stringify(property));

			this.propertyService.updateSitePriority(property)
				.subscribe(
					res => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.alertService.success(res, true);
						// this.router.navigate(['/property-view', this.shortTermRentalId]);
					},
					err => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {  });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

    exportSelected($event: any) {
      this.importExportComponent.exporData($event, this.properties, 'Properties List');
    }

	loadLazyForExport(exporttype: string) {
		let event = this.lazyLoadEvent;
		event.rows = 1000;
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			const pageNumber = Math.round(event.first / event.rows);
			this.propertyService.findAgentListByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

				data => {
					console.log('properties are: ' + JSON.stringify(data));
					this.datasource = data.data.properties;
					this.recordTotal = data.page.recordTotal;
          let datList = data.data.properties;
          datList.forEach( data => {
            data.lastUpdate = moment.utc(data.lastUpdate).format('MM/DD/YYYY');
          });
					this.importExportComponent.exporData(exporttype, datList, 'Properties List');
				},
				error => {
					console.log('properties list error!: ' + JSON.stringify(error));
					this.alertService.error(error);
				},
				() => { this.loading = false; }
			);

			if (this.datasource) {
				this.properties = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}
  openPublicTaskList() {
    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      title: 'Tasks',
      taskSource: 9,
      showFilter: true
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(PublicTaskListComponent, dialogConfig);

  }

  getListingTypeName(listingType: any) {
	if (listingType) {
		const status = this.listingTypes.find((e: any) => e.value == listingType);
		return status.name;
	}
	else {
		return '';
	}
}

	onDeletePropertyClick(event: Event, property: any) {
		event.stopPropagation();
		this.router.navigate(['property-delete', property.shortTermRentalId]);
	}

}
